import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavigationExtras, Router, RouterOutlet } from '@angular/router';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { ExcelExportEvent, KENDO_GRID, KENDO_GRID_EXCEL_EXPORT } from '@progress/kendo-angular-grid';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { KENDO_BREADCRUMB } from '@progress/kendo-angular-navigation';
import { cloudIcon, fileExcelIcon, pencilIcon, trashIcon } from '@progress/kendo-svg-icons';
import { DraftsI, ObjectsI, ProjectsI } from '../../_models/projects';
import { ProjectsService } from '../../_services/projects.service';
import { FlatBindingDirective } from '@progress/kendo-angular-treelist';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { UploadService } from '../../_services/upload.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropDownListModule, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { formatDate } from '../../globals';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { NotificationService } from '@progress/kendo-angular-notification';
import { SubjectService } from '../../_services/subject.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators'

@Component({
    selector: 'app-draft-upload',
    imports: [KENDO_SVGICON, KENDO_BUTTON, KENDO_GRID, KENDO_BREADCRUMB, KENDO_GRID_EXCEL_EXPORT, InputsModule, ReactiveFormsModule, DropDownListModule, DropDownsModule,
        LayoutModule, CommonModule, DialogModule],
    templateUrl: './draft-upload.component.html',
    styleUrl: './draft-upload.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class DraftUploadComponent implements OnInit, OnDestroy {
  drafts: DraftsI[] = [];
  projects: ProjectsI[] = [];
  filteredProjects: ProjectsI[] = [];
  filteredPortalObjects: ObjectsI[] = [];
  portalObjects: ObjectsI[] = [];
  selection: any[] = [];
  width = '300';
  svgIcon = [cloudIcon, fileExcelIcon, pencilIcon, trashIcon];
  copyDrafts: DraftsI[] = [];
  projectId: number = 0;
  objectId: number = 0;
  data: any;
  form!: FormGroup;
  loading1 = false;
  loading2 = false;
  loading = false;
  showConfirmDialog: boolean = false;
  accessType = '';
  deleteConfirmationMessage: string = '';
  selectedUpload: any = null;
  roleDescription: string = '';
  isAdmin: boolean = false;
  private destroy$ = new Subject<void>();
  @ViewChild(FlatBindingDirective) dataBinding!: FlatBindingDirective;
  constructor(private service: ProjectsService, private cdr: ChangeDetectorRef,
    private router: Router, private uploadService: UploadService, private fb: FormBuilder,
    private notificationService: NotificationService, private sub: SubjectService) {
    this.form = this.fb.group({
      project: {
        projectname: "Select a Project..",
        projectId: null
      },
      purchaseOrder: {
        name: 'Select an Order No..',
        id: null,
      },
      companyname: null,
    });
    this.getProjectsList();
    const currentNavigation = this.router.getCurrentNavigation();
    if (currentNavigation?.extras.state) {
      const url = currentNavigation.extras.state['url'];
      this.data = url?.split('/');
      this.projectId = this.data[0];
      this.objectId = this.data[1];
      this.accessType = this.data[4];
      this.form.patchValue({
        project: {
          projectId: this.data[0],
          projectname: this.data[2],
        },
        purchaseOrder: {
          name: ['ADMIN', 'UPLOAD'].includes(this.data[4]) ? this.data[3] : 'Select an Order No..',
          id: ['ADMIN', 'UPLOAD'].includes(this.data[4]) ? this.data[1] : null,
        },
        companyname: this.data[5],
      });
    }
    if (this.form.value.project.projectId) {
      sessionStorage.setItem('project-id', JSON.stringify(this.form.value.project.projectId));
      sessionStorage.setItem('project-name', JSON.stringify(this.form.value.project.projectname));
      sessionStorage.setItem('poid', JSON.stringify(this.form.value.purchaseOrder.id));
      sessionStorage.setItem('po-name', JSON.stringify(this.form.value.purchaseOrder.name));
      sessionStorage.setItem('po-companyName', JSON.stringify(this.form.value.companyname));
      this.form.get('purchaseOrder')?.enable();
      this.getPO();
    } else {
      // this.form.get('purchaseOrder')?.disable();
      if (sessionStorage.getItem('project-id')) {
        let pname = JSON.parse(sessionStorage.getItem('project-name') || '');
        let pid = JSON.parse(sessionStorage.getItem('project-id') || '');
        let poname = JSON.parse(sessionStorage.getItem('po-name') || '');
        let poid = JSON.parse(sessionStorage.getItem('poid') || '');
        let poCompanyName = sessionStorage.getItem('po-companyName') || '';
        this.form.patchValue({
          project: {
            projectname: pname,
            projectId: pid
          },
          purchaseOrder: {
            name: poname,
            id: poid
          },
          companyname: poCompanyName
        });
        this.getPO();
      }
      else {
        this.form.get('purchaseOrder')?.disable();
      }
    }
    if (this.form.value?.purchaseOrder?.id) {
      this.getDraftUploads();
    }
    const cachedUserData = sessionStorage.getItem('userData');
    if (cachedUserData) {
      let userData = JSON.parse(cachedUserData);
      this.isAdmin = userData.usertype === 'A' ? true : false;
    }
  }
  ngOnInit(): void {
    this.sub.refreshTrigger$
      .pipe(
        takeUntil(this.destroy$),
        filter(trigger => trigger === 'drafts')
      )
      .subscribe(() => {
        this.getProjectsList();
        if(this.form.value.project.projectId) this.getPO();
       if(this.form.value.project?.projectId && this.form.value?.purchaseOrder?.id) this.getDraftUploads();
        this.cdr.markForCheck();
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  getPO() {
    this.portalObjects = [];
    this.loading1 = true;
    this.service.purchaseOrders(this.form.value.project.projectId).subscribe({
      next: (result) => {
        // this.portalObjects = result;
        if (result.filter(obj => ['ADMIN', 'UPLOAD'].includes(obj.accessType)).length) {
          this.portalObjects = result.filter(obj => ['ADMIN', 'UPLOAD'].includes(obj.accessType));
        } else {
          this.portalObjects = [];
        }
        this.filteredPortalObjects = this.portalObjects;
        // this.portalObjects = result.filter(obj => ['ADMIN', 'UPLOAD'].includes(obj.accessType));

        // in case user update company of order and returns to the screen
        if (this.form.value?.purchaseOrder?.id) {

          //get updated company for order
          let selectedOrder = this.portalObjects.find(o => o.id == this.form.value.purchaseOrder.id);
          sessionStorage.setItem('po-companyName', selectedOrder!.companyName);
          this.form.patchValue({ companyname: selectedOrder!.companyName });
        }
        this.loading1 = false;
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.log(error)
      },
      complete: () => {
      }
    });
  }
  getProjectsList() {
    this.loading2 = true;
    this.service.getProjects().subscribe(res => {
      this.projects = res;
      this.filteredProjects = this.projects;
      this.loading2 = false;
      this.cdr.markForCheck();
    });
  }
  getObjectsForProjects(event: any) {
    this.loading1 = true;
    this.drafts = [];
    // this.fileData = [];
    if (this.form.value.project.projectId) {
      this.form.get('purchaseOrder')?.enable();
      this.form.patchValue({
        purchaseOrder: {
          id: null,
          name: 'Select an Order No..'
        },
        companyname: null,
      });
      if (!this.form.value.purchaseOrder.id) {
        this.drafts = [];
        this.copyDrafts = [];
      }
      this.service.purchaseOrders(+event?.projectId).subscribe({
        next: (result) => {
          if (result.filter(obj => ['ADMIN', 'UPLOAD'].includes(obj.accessType)).length) {
            this.portalObjects = result.filter(obj => ['ADMIN', 'UPLOAD'].includes(obj.accessType));
          } else {
            this.portalObjects = [];
          }
          this.filteredPortalObjects = this.portalObjects;

          // this.copyPurchaseOrders = this.portalObjects;
          this.loading1 = false;
          this.cdr.markForCheck();
        },
        error: (error) => {
          //throw message of some sort
          console.log(error)
        },
        complete: () => {
          for (var i = 0; i < this.portalObjects.length; i++) {
            if (this.portalObjects[i].maxuploaddate != null) {
              this.portalObjects[i].maxuploaddate = new Date(this.portalObjects[i].maxuploaddate);
            }
          }
        }

      });
    }
  }
  getDraftUploads() {
    this.loading = true;
    let companyName = this.form.value.purchaseOrder?.companyName ? this.form.value.purchaseOrder?.companyName :
      this.form.value?.companyname ? this.form.value?.companyname : sessionStorage.getItem('po-companyName') ? sessionStorage.getItem('po-companyName') : '';
    this.form.patchValue({ companyname: companyName });
    this.service.draftUploads(this.form.value.project?.projectId, this.form.value?.purchaseOrder?.id).subscribe({
      next: (result) => {
        this.drafts = result.filter(obj => obj.status == 'Draft');
        this.copyDrafts = this.drafts;
        sessionStorage.setItem('project-id', JSON.stringify(this.form.value.project.projectId));
        sessionStorage.setItem('project-name', JSON.stringify(this.form.value.project.projectname));
        sessionStorage.setItem('poid', JSON.stringify(this.form.value.purchaseOrder.id));
        sessionStorage.setItem('po-name', JSON.stringify(this.form.value.purchaseOrder.name));
        sessionStorage.setItem('po-companyName', companyName);
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
      },
      complete: () => {
        for (var i = 0; i < this.drafts.length; i++) {
          if (this.drafts[i].uploadDate != null) {

            this.drafts[i].uploadDate = new Date(formatDate(this.drafts[i].uploadDate));

          }
        }
      }

    });

    // this.service.getProjects().subscribe(res => {
    //   this.projects = res;
    //   this.copyProjects = this.projects;
    //   this.cdr.markForCheck();
    // })
  }

  convertDate(value: Date): Date {
    const dateValue = new Date(value);

    const timezoneOffset = dateValue.getTimezoneOffset(); // Offset in minutes

    const localDate = new Date(dateValue.getTime() + timezoneOffset * 60 * 1000);

    return localDate;
  }

  public rowCallback = (context: any) => {
    return {
      'hide-row': context.dataItem.totalpocount == 0
    };
  };
  public onFilter(value: string): void {
    const scalingFactor = 7; // This value depends on the font size and family
    const characterCount = value.length;
    const newWidth = Math.max(50, characterCount * scalingFactor);
    if (+this.width < 400) {
      if (newWidth - 100 > 0 && newWidth - 100 < 500) {
        this.width = (newWidth + 200).toString();
      }
    }
    if (value.length) {
      this.drafts = this.copyDrafts.filter(obj => obj.uploadedBy.toLocaleLowerCase().includes(value.toLowerCase()));
    } else {
      this.drafts = this.copyDrafts;
      this.width = '300';
    }
  }
  navigate(str: string, count: number, dataItem?: any) {
    if (count > 0) {
      if (str == 'upload') {
        sessionStorage.setItem('selected', JSON.stringify(false));
        this.router.navigate(['portal']);
      } else {
        const navigationExtras: NavigationExtras = {
          state: {
            url: `${dataItem.projectId}/${dataItem.projectname}`
          }
        };
        this.router.navigate(['/purchase-orders'], navigationExtras);
      }
    }
  }
  editUpload(dataItem: any) {
    this.uploadService.getUploadedFiles(dataItem.uploadId).subscribe(res => {
      if (res.length) {
        const navigationExtras: NavigationExtras = {
          state: {
            url: `${dataItem.projectId}/${dataItem.projectName}/${dataItem.objectName}/${dataItem.objectId}/${dataItem.uploadId}/${res[0].filename}/${res[0].filesize}`
          }
        };
        this.router.navigate(['/upload'], navigationExtras);
      } else {
        const navigationExtras: NavigationExtras = {
          state: {
            url: `${dataItem.projectId}/${dataItem.projectName}/${dataItem.objectName}/${dataItem.objectId}/${dataItem.uploadId}`
          }
        };
        this.router.navigate(['/upload'], navigationExtras);
      }
    });
  }
  getCount(totalpocount: number, pocount: number) {
    return totalpocount > 0 ? `${pocount} (${totalpocount})` : pocount
  }
  getAllCount(totaluploadcount: number, filecount: number) {
    return filecount > 0 ? `${totaluploadcount} (${filecount})` : totaluploadcount
  }
  getFileName() {
    let str = 'Draft Uploads';
    return `${str} ${this.getFormattedDate()}.xlsx`
  }
  getFormattedDate(): string {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  onExcelExport(e: ExcelExportEvent): void {
    const sheet = e.workbook.sheets[0];
    const header = sheet.rows[0];
    const getIndex = (field: string) => header.cells.findIndex((c: any) => c?.value === field);
    const background = header.cells[0]?.background;
    const color = header.cells[0]?.color;
    const columnsToRemove = ['Project Name', 'Order No.', 'Order Description'];
    const removeIndexes = header.cells
      .map((c: any, i: any) => columnsToRemove.includes(c?.value) ? i : -1)
      .filter((i: any) => i !== -1);

    removeIndexes.slice().reverse().forEach((i: any) => header.cells.splice(i, 1));

    sheet.rows
      .filter((r: any) => r.type === 'data')
      .forEach((row: any) => {
        removeIndexes.slice().reverse().forEach((i: any) => row.cells.splice(i, 1));
      });

    const dateCount = getIndex('Upload Date');
    const companyName = this.form.value.companyname;

    this.drafts.forEach((item, i) => {
      const row = sheet.rows[i + 1];
      if (!row || row.type !== 'data') return;

      row.cells[dateCount].value = item.uploadDate ? formatDate(item.uploadDate) : null;

      row.cells.unshift(
        { value: item.projectId },
        { value: item.projectName },
        { value: item.objectName },
        { value: companyName },
        { value: item.objectDescription }
      );
    });

    header.cells.unshift(
      { value: 'Project ID', background, color },
      { value: 'Project Name', background, color },
      { value: 'Order No.', background, color },
      { value: 'Company', background, color },
      { value: 'Order Description', background, color },
    )
  }

  deleteConfirmation(dataItem: DraftsI) {
    this.showConfirmDialog = true;
    this.deleteConfirmationMessage = 'Are you sure you want to delete Draft ' + dataItem.uploadId + ' ?';
    this.selectedUpload = dataItem;
  }

  deleteUpload() {
    this.loading = true;
    this.uploadService.deleteUpload(this.selectedUpload?.uploadId, this.form.value?.purchaseOrder?.id).subscribe({
      next: (result) => {
        this.selectedUpload = null;
      },
      error: (error) => {
        this.selectedUpload = null;
        this.loading = false;
        this.cdr.markForCheck();
        this.showError(JSON.stringify(error.message));
      },
      complete: () => {
        this.showConfirmDialog = false;
        this.loading = false;
        this.cdr.markForCheck();
        this.getDraftUploads();
      }

    });
  }

  closeDialog() {
    this.showConfirmDialog = false;
    this.deleteConfirmationMessage = '';
  }

  public showError(value: string): void {
    this.notificationService.show({
      content: value,

      hideAfter: 10000,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "slide", duration: 400 },
      type: { style: "error", icon: true },
    });
  }

  selectionChange(event: any) {
    if (event.accessType === 'VIEW') {
      this.roleDescription = 'View Role';
    }
    if (event.accessType === 'UPLOAD') {
      this.roleDescription = 'Upload Role';
    }
    if (event.accessType === 'PROCESS') {
      this.roleDescription = 'Process Role';
    }
    if (event.accessType === 'ADMIN') {
      this.roleDescription = 'Full Admin';
    }
  }

  actionsCondition(dataItem: any) {
    return !(this.isAdmin || (dataItem.accessType != 'VIEW' && dataItem.accessType != 'PROCESS'));
  }

  onProjectFilter(value: string): void {
    console.log("this.filteredProjects", this.filteredProjects, value)
    this.filteredProjects = this.projects.filter(p =>
      p.projectname && p.projectname.toLowerCase().includes(value.toLowerCase())
    );

    console.log("this.filteredProjects--->", this.filteredProjects)
  }

  onOrderFilter(value: string): void {
    this.filteredPortalObjects = this.portalObjects.filter(p =>
      p.name && p.name.toLowerCase().includes(value.toLowerCase())
    );
  }
}

